import Interceptor from "@/plugins/interceptor.js"

const urlAPI = `${process.env.VUE_APP_API_URL_SECURITY}${process.env.VUE_APP_API_PROFILE}`

const Profile = {
  state: {
    profile: {},
    imagePreview: ""
  },
  actions: {
    profileGet: async ({ commit }) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/get`)
        commit('SET_profile', response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    profileUpdate: async ({ commit }, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/update`, model)
        commit('SET_profile', model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    updateImageProfile: async({ commit, state }, url) => {
      try {
        commit('SET_imageProfile', url)
        const response = await Interceptor.put(`${urlAPI}/update`, state.profile)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    imageModalCropImageProfile: ({commit}, image) => {
      commit('SET_imageProfilePreview', image)
    },
  },
  mutations: {
    SET_profile(state, value) {
      state.profile = value
    },
    SET_imageProfile(state, value) {
      state.profile.picture = value
    },
    SET_imageProfilePreview(state, value) {
      state.imagePreview = value
    }
  }
}

export default Profile